import { useMutation } from "@apollo/client";
import { useSetRecoilState } from "recoil";
import { analytics } from "MVVM/Analytics";
import {
  MOMENT_REQUEST_CLIP,
  MOMENT_CREATE_CLIP,
} from "MVVM/GraphQL/mutations/momentRequestClip";
import { PulseKickAtom } from "MVVM/State/clipStatus";

export const MomentViewModel = () => {
  const kickPulse = useSetRecoilState(PulseKickAtom);

  const [momentRequestClip] = useMutation(MOMENT_REQUEST_CLIP, {
    onError: (err: any) => {
      console.log(`mutateReaction error! ${err.message}`);
    },
    onCompleted: () => kickPulse((n) => n + 1),
  });

  const [momentCreateClip] = useMutation(MOMENT_CREATE_CLIP, {
    onError: (err: any) => {
      analytics.track("MomentCreateClipError", {
        errorMessage: err.message,
      });
    },
    onCompleted: () => kickPulse((n) => n + 1),
  });

  return {
    momentRequestClip,
    momentCreateClip,
  };
};
